import { render } from "./DataviewHeader.vue?vue&type=template&id=4f98d258"
import script from "./DataviewHeader.vue?vue&type=script&lang=js"
export * from "./DataviewHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__